/** @file Joins CSS class names, skipping empty and falsy parts. */

/** Returns the non-empty string parts joined by single spaces. */
export function joinClass(...parts: readonly (string | false | null | undefined)[]): string {
  return parts.filter((part): part is string => typeof part === 'string' && part !== '').join(' ');
}
